import {
    create,
    multiplyDependencies,
    divideDependencies,
    chainDependencies,
    bignumberDependencies,
    roundDependencies,
} from "mathjs";

// create a math instance only with dependencies in use

const config = { number: "BigNumber" };
const math = create(
    {
        multiplyDependencies,
        divideDependencies,
        chainDependencies,
        bignumberDependencies,
        roundDependencies,
    },
    config
);

export default math;
